import { useMemo } from "react";
import { FieldDate, FieldInput, FieldSelect } from "../../../../../_CORE/APP/Templates/_UI/Form/_index";
import { AdvancedFilterPanel } from "../../../../_UI/AdvancedFilterPanel";
import { NOTEBOOK_TYPES, NOTEBOOK_STATUSES } from "./NotebookEntryFormModal";

export const NOTEBOOK_ADVANCED_FILTER_EMPTY = {
    collectionId: "ALL",
    type: "ALL",
    status: "ALL",
    isFavorite: "ALL",
    author: "",
    tag: "",
    dateField: "UPDATED",
    dateRange: [null, null],
    dateExact: null,
};

export const cloneNotebookAdvancedFilters = (value = NOTEBOOK_ADVANCED_FILTER_EMPTY) => ({
    ...NOTEBOOK_ADVANCED_FILTER_EMPTY,
    ...value,
    dateRange: Array.isArray(value?.dateRange) ? [...value.dateRange] : [null, null],
    dateExact: value?.dateExact || null,
});

export const onNotebookAdvancedFilterCount = (value = NOTEBOOK_ADVANCED_FILTER_EMPTY) => {
    const filters = cloneNotebookAdvancedFilters(value);
    let count = 0;
    if (filters.collectionId !== "ALL") count += 1;
    if (filters.type !== "ALL") count += 1;
    if (filters.status !== "ALL") count += 1;
    if (filters.isFavorite !== "ALL") count += 1;
    if (String(filters.author || "").trim()) count += 1;
    if (String(filters.tag || "").trim()) count += 1;
    if (filters.dateRange?.[0] || filters.dateRange?.[1]) count += 1;
    if (filters.dateExact) count += 1;
    return count;
};

export const NotebookAdvancedFilterPanel = ({
    isOpen,
    value,
    onChange,
    onClear,
    collections = [],
}) => {
    const filters = cloneNotebookAdvancedFilters(value);
    const set = (key, nextValue) => onChange?.({ ...filters, [key]: nextValue });

    const collectionOptions = useMemo(() => [
        { value: "ALL", label: "Todas las colecciones" },
        { value: "NONE", label: "Sin colección" },
        ...collections.map((collection) => ({ value: String(collection.id), label: collection.name })),
    ], [collections]);

    return <AdvancedFilterPanel isOpen={isOpen} activeCount={onNotebookAdvancedFilterCount(filters)} onClear={onClear}>
        <FieldSelect id="notebook_adv_collection" label="Colección" value={filters.collectionId}
            onChange={(event) => set("collectionId", event.target.value)} options={collectionOptions} />
        <FieldSelect id="notebook_adv_type" label="Tipo" value={filters.type}
            onChange={(event) => set("type", event.target.value)} options={[{ value: "ALL", label: "Todos" }, ...NOTEBOOK_TYPES]} />
        <FieldSelect id="notebook_adv_status" label="Estado" value={filters.status}
            onChange={(event) => set("status", event.target.value)} options={[{ value: "ALL", label: "Todos" }, ...NOTEBOOK_STATUSES]} />
        <FieldSelect id="notebook_adv_favorite" label="Destacado" value={filters.isFavorite}
            onChange={(event) => set("isFavorite", event.target.value)} options={[
                { value: "ALL", label: "Todos" }, { value: "YES", label: "Sólo destacados" }, { value: "NO", label: "No destacados" },
            ]} />
        <FieldInput id="notebook_adv_author" label="Autor / responsable" value={filters.author}
            onChange={(event) => set("author", event.target.value)} placeholder="Nombre o responsable" />
        <FieldInput id="notebook_adv_tag" label="Etiqueta" value={filters.tag}
            onChange={(event) => set("tag", event.target.value)} placeholder="Ej: Reflactor" />
        <FieldSelect id="notebook_adv_date_field" label="Fecha" value={filters.dateField}
            onChange={(event) => set("dateField", event.target.value)} options={[
                { value: "UPDATED", label: "Última actualización" },
                { value: "CREATED", label: "Fecha de creación" },
            ]} />
        <FieldDate id="notebook_adv_date_from" label="Desde" value={filters.dateRange?.[0] || null}
            onChange={(date) => onChange?.({ ...filters, dateRange: [date || null, filters.dateRange?.[1] || null], dateExact: null })} isClearable />
        <FieldDate id="notebook_adv_date_to" label="Hasta" value={filters.dateRange?.[1] || null}
            onChange={(date) => onChange?.({ ...filters, dateRange: [filters.dateRange?.[0] || null, date || null], dateExact: null })} isClearable />
        <FieldDate id="notebook_adv_date_exact" label="Fecha exacta" value={filters.dateExact}
            onChange={(date) => onChange?.({ ...filters, dateExact: date || null, dateRange: date ? [null, null] : filters.dateRange })} isClearable />
    </AdvancedFilterPanel>;
};

/* Alias temporal para no romper imports antiguos externos al módulo. */
export const NotebookAdvancedFilterModal = NotebookAdvancedFilterPanel;
